import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import ProcessTimeline from './components/ProcessTimeline';
import Differentiation from './components/Differentiation';
import TargetAudience from './components/TargetAudience';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <ProcessTimeline />
        <Differentiation />
        <TargetAudience />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
